export default "__VITE_ASSET__DvUXZdZR__"